import axios from 'axios'
import authHeader from './auth-header'
import Vue from 'vue'

class CrashLogService {
  /**
   * دریافت لیست لاگ‌های خطا
   * @param {Object} payload - پارامترهای فیلتر و صفحه‌بندی
   */
  getAll(payload = {}) {
    const promise = axios.post(
      `${Vue.prototype.$apiServers.url}/admin/crash-logs/list`,
      payload,
      { headers: authHeader() }
    )
    return promise.then(response => response.data)
  }

  /**
   * دریافت جزئیات یک لاگ خطا
   * @param {String} logId - شناسه لاگ
   */
  getDetail(logId) {
    const promise = axios.post(
      `${Vue.prototype.$apiServers.url}/admin/crash-logs/detail`,
      { logId },
      { headers: authHeader() }
    )
    return promise.then(response => response.data)
  }

  /**
   * علامت‌گذاری لاگ به عنوان بررسی شده
   * @param {String} logId - شناسه لاگ
   * @param {Boolean} isReviewed - وضعیت بررسی
   * @param {String} reviewNote - یادداشت بررسی
   */
  review(logId, isReviewed = true, reviewNote = null) {
    const promise = axios.post(
      `${Vue.prototype.$apiServers.url}/admin/crash-logs/review`,
      { logId, isReviewed, reviewNote },
      { headers: authHeader() }
    )
    return promise.then(response => response.data)
  }

  /**
   * حذف یک لاگ خطا
   * @param {String} logId - شناسه لاگ
   */
  delete(logId) {
    const promise = axios.post(
      `${Vue.prototype.$apiServers.url}/admin/crash-logs/delete`,
      { logId },
      { headers: authHeader() }
    )
    return promise.then(response => response.data)
  }

  /**
   * حذف همه لاگ‌های خطا
   */
  deleteAll() {
    const promise = axios.post(
      `${Vue.prototype.$apiServers.url}/admin/crash-logs/delete-all`,
      {},
      { headers: authHeader() }
    )
    return promise.then(response => response.data)
  }

  /**
   * دریافت آمار لاگ‌های خطا
   */
  getStats() {
    const promise = axios.post(
      `${Vue.prototype.$apiServers.url}/admin/crash-logs/stats`,
      {},
      { headers: authHeader() }
    )
    return promise.then(response => response.data)
  }
}

export default new CrashLogService()
